<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-camera-permissions"
      v-model="allSelected"
      name="select-all-menu-camera-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item>
        <div class="row">
          <div
            v-for="(option, index) in networkWithoutChildrenOptions"
            :key="index"
            class="col-6"
          >
            <b-form-checkbox
              :id="`option-camera-${index}`"
              v-model="itemData.DeviceMenuAccess"
              :name="option.value"
              class="text-capitalize mt-1"
              switch
              :value="option.value"
            >
              {{ option.label }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
  <!-- <b-list-group>
    <b-list-group-item v-for="(option, index) in networkWithChildrenOptions" :key="index">
      <p class="h5 mb-1">{{ option.label }}</p>
      <div class="row">
        <div
          v-for="(optionChildren, indexChildren) in option.children"
          :key="indexChildren"
          class="col-6"
        >
          <b-form-checkbox
            :id="`option-children-${indexChildren}`"
            v-model="itemData.NetworkMenuAccess"
            :name="`option-children-${indexChildren}`"
            class="text-capitalize"
            switch
            :value="optionChildren.value"
          >
            {{ optionChildren.label }}
          </b-form-checkbox>
        </div>
      </div>
    </b-list-group-item>
    <b-list-group-item>

    </b-list-group-item>
  </b-list-group> -->
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const networkWithChildrenOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.network.ip_port'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.ip'),
            value: 'NetworkInterface'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.network.port'),
            value: 'NetworkPort'
          }
        ],
      }
    ];

    const networkWithoutChildrenOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.camera.register'),
        value: 'CameraRegistration'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.camera.channel_setup'),
        value: 'ChannelSetup'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.camera.camera_setup'),
        value: 'CameraSetup'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.camera.camera_password'),
        value: 'CameraPassword'
      }
    ];

    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "DeviceMenuAccess",
      flattenOptionValues(networkWithoutChildrenOptions)
    );

    return { allSelected, networkWithChildrenOptions, networkWithoutChildrenOptions }
  }
}
</script>
